<template>
    <div class="card cart-card-div">
        <div v-for="(renter, key, index) in renters" :key="key"
             v-if="renters && renters.length > 0">
            <table class="table table-border-none renter-summary-table" style="max-width:100%">
                <thead>
                <tr>
                    <th class="item-name">{{ renter.first_name }} {{ renter.last_name }}</th>
                    <th class="text-center">{{trans('cart.RATE','RATE')}}</th>
                    <th class="text-center" width="10px"></th>
                    <th class="text-center">{{trans('cart.DAYS','DAYS')}}</th>
                    <th class="text-center" width="10px"></th>
                    <th class="text-right">TOTAL</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="coupon && isPackageEligibleForDiscount(renter)">
                    <td>{{ trans('step2.packages.#'+renter.package_id+'.name',renter.package_name) }} <span class="text-success">(Discounted)</span></td>
                    <td class="text-center">
                        <del class="text-danger">{{ currency_sign }}{{ thousandSeparator(renter.package_price) }}</del>
                        {{ currency_sign }}{{ thousandSeparator(getDiscountedPrice(renter.package_price, coupon.discount)) }}
<!--                        <small v-if="renter.package_max_price">-->
<!--                            (Max Price {{ currency_sign }}{{ thousandSeparator(renter.package_max_price) }})-->
<!--                        </small>-->
                    </td>
                    <td class="text-center">x</td>
                    <td class="text-center">{{ renter.number_of_days }}</td>
                    <td class="text-center">=</td>
                    <td class="text-right">{{currency_sign}}{{thousandSeparator(getDiscountedPrice(renter.package_price, coupon.discount) * renter.number_of_days) }}</td>
                </tr>
                <tr v-else-if="coupon && !isPackageEligibleForDiscount(renter)">
                    <td>{{ trans('step2.packages.#'+renter.package_id+'.name',renter.package_name) }} <span class="text-muted">(No Discount)</span></td>
                    <td class="text-center">
                        {{ currency_sign }}{{ thousandSeparator(renter.package_price) }}
<!--                        <small v-if="renter.package_max_price">-->
<!--                            (Max Price {{ currency_sign }}{{ thousandSeparator(renter.package_max_price) }})-->
<!--                        </small>-->
                    </td>
                    <td class="text-center">x</td>
                    <td class="text-center">{{ renter.number_of_days }}</td>
                    <td class="text-center">=</td>
                    <td class="text-right">{{currency_sign}}{{thousandSeparator(renter.package_price * renter.number_of_days) }}</td>
                </tr>
                <tr v-else>
                    <td>{{ trans('step2.packages.#'+renter.package_id+'.name',renter.package_name) }}</td>
                    <td class="text-center">
                        {{ currency_sign }}{{thousandSeparator(renter.package_price)}}
<!--                        <small v-if="renter.package_max_price">-->
<!--                            (Max Price {{ currency_sign }}{{ thousandSeparator(renter.package_max_price) }})-->
<!--                        </small>-->
                    </td>
                    <td class="text-center">x</td>
                    <td class="text-center">{{ renter.number_of_days }}</td>
                    <td class="text-center">=</td>
                    <td class="text-right">{{currency_sign }}{{ thousandSeparator(renter.package_price * renter.number_of_days) }}</td>
                </tr>
                <tr v-for="add_on in renter.add_ons" :key="'addon-'+renter.id+'-'+add_on.id"
                    v-if="renter.add_ons && renter.add_ons.length > 0">
                    <td>
                        {{ trans('step2.addons.#'+add_on.id+'.name',add_on.name) }}
                        <span v-if="coupon && coupon.addon_discount && isAddonEligibleForDiscount(add_on)" class="text-success">(Discounted)</span>
                    </td>
                    <td class="text-center" v-if="coupon && coupon.addon_discount && isAddonEligibleForDiscount(add_on)">
                        <del class="text-danger">{{currency_sign}}{{ thousandSeparator(getAddonDailyPrice(add_on) * add_on.qty) }}</del>
                        {{currency_sign}}{{ thousandSeparator(getDiscountedAddonUnitPrice(add_on) * add_on.qty) }}
                    </td>
                    <td class="text-center" v-else>
                        {{currency_sign}}{{ thousandSeparator(getAddonDailyPrice(add_on) * add_on.qty) }}
                    </td>
                    <td class="text-center">{{ add_on.pricing === 'one_time' ? '' : 'x' }}</td>
                    <td class="text-center">{{ add_on.pricing === 'one_time' ? '' : renter.number_of_days }}</td>
                    <td class="text-center">=</td>
                    <td class="text-right" v-if="add_on.pricing === 'one_time'">
                        {{currency_sign}}{{ thousandSeparator(getDiscountedAddonLineTotal(add_on, renter, 1)) }}
                    </td>
                    <td class="text-right" v-else>
                        {{currency_sign}}{{ thousandSeparator(getDiscountedAddonLineTotal(add_on, renter, renter.number_of_days)) }}
                    </td>
                </tr>
                <tr v-if="renter.clothing_resort_id">
                    <td>
                        {{ trans('step2.clothing.#'+renter.clothing_resort_id+'.name',renter.clothing_name) }}
                        <span v-if="coupon && coupon.addon_discount" class="text-success">(Discounted)</span>
                    </td>
                    <td class="text-center" v-if="coupon && coupon.addon_discount">
                        <del class="text-danger">{{ currency_sign }}{{ thousandSeparator(renter.clothing_price) }}</del>
                        {{ currency_sign }}{{ thousandSeparator(getDiscountedPrice(renter.clothing_price, coupon.addon_discount)) }}
                    </td>
                    <td class="text-center" v-else>{{ currency_sign }}{{ thousandSeparator(renter.clothing_price) }}</td>
                    <td class="text-center">x</td>
                    <td class="text-center">{{ renter.number_of_days }}</td>
                    <td class="text-center">=</td>
                    <td class="text-right" v-if="coupon && coupon.addon_discount">
                        {{ currency_sign }}{{ thousandSeparator(getDiscountedPrice(renter.clothing_price, coupon.addon_discount) * renter.number_of_days) }}
                    </td>
                    <td class="text-right" v-else>
                        {{ currency_sign }}{{ thousandSeparator(renter.clothing_price * renter.number_of_days) }}
                    </td>
                </tr>
                <tr>
                    <th colspan="5">{{trans('cart.Total','Total')}}</th>
                    <th class="text-right">
                        {{currency_sign }}{{ thousandSeparator(getDiscountedRenterTotal(renter))}}
                    </th>
                </tr>
                <tr class="visible-xs" v-if="($route && $route.name !== 'Step3' && $route.name !=='Step4' && $route.name !== 'Step5') || fromWp">
                    <th colspan="10" class="text-right">
                        <a href="Javascript:void(0);" @click="deleteRenter(renter, key)"><img
                            :src="base_url+'/cart-booking/static/assets/images/delete.png'" alt=""></a>
                    </th>
                </tr>

                </tbody>
            </table><hr/>
        </div>
        <table class="table table-border-none  summary-totals-table">
            <tbody>
            <tr v-for="(invoiceAddon, invAddonKey) in cart.invoice_addons"
                :key="'inv_addon_'+invAddonKey" v-if="cart.invoice_addons && cart.invoice_addons.length > 0">
                <td colspan="3">
                    {{ trans('step2.addons.#'+invoiceAddon.id+'.name', invoiceAddon.name) }}
                </td>
                <td colspan="3">
                    <span v-if="invoiceAddon.pricing === 'percent'" class="pull-right">
                                                  {{ thousandSeparator(invoiceAddon.price) }}%
                                                <small v-if="invoiceAddon.max_price">
                                                    ({{trans('cart.max_price','Max Price')}} {{ currency_sign }}{{
                                                        thousandSeparator(invoiceAddon.max_price)
                                                    }})
                                                </small>

                                                = {{
                                             currency_sign
                                         }}{{
                                             thousandSeparator(getStaticPercentPrice(cart.discounted_package_total, invoiceAddon.price, invoiceAddon.max_price) * parseInt(invoiceAddon.qty))
                                         }}
                                            </span>
                    <span class="pull-right" v-else-if="invoiceAddon.pricing === 'one_time'">
                        <template v-if="coupon && coupon.addon_discount && isAddonEligibleForDiscount(invoiceAddon)">
                            <del class="text-danger">{{ currency_sign }}{{thousandSeparator(getAddonDailyPrice(invoiceAddon)) }}</del>
                            {{ currency_sign }}{{thousandSeparator(getDiscountedAddonUnitPrice(invoiceAddon)) }}
                        </template>
                        <template v-else>
                            {{ currency_sign }}{{thousandSeparator(getAddonDailyPrice(invoiceAddon)) }}
                        </template>
                        <small v-if="invoiceAddon.max_price">({{trans('cart.max_price','Max Price')}} {{ currency_sign }}{{ thousandSeparator(invoiceAddon.max_price)</small>
                         = {{ currency_sign }}{{thousandSeparator(getDiscountedInvoiceAddonLineTotal(invoiceAddon, 1)) }}
                    </span>
                    <span v-else class="pull-right">
                        <template v-if="coupon && coupon.addon_discount && isAddonEligibleForDiscount(invoiceAddon)">
                            <del class="text-danger">{{ currency_sign }}{{thousandSeparator(getAddonDailyPrice(invoiceAddon)) }}/DAY</del>
                            {{ currency_sign }}{{thousandSeparator(getDiscountedAddonUnitPrice(invoiceAddon)) }}/DAY
                        </template>
                        <template v-else>
                            {{ currency_sign }}{{thousandSeparator(getAddonDailyPrice(invoiceAddon)) }}/DAY
                        </template>
                                            <small v-if="invoiceAddon.max_price">
                                                ({{trans('cart.max_price','Max Price')}} {{ currency_sign }}{{ thousandSeparator(invoiceAddon.max_price)
                                            </small>
                                                &nbsp;x &nbsp; {{ getRentalLength() }}
                                                {{trans('cart.DAYS','DAYS')}}
                                                = {{ currency_sign }}{{
                            thousandSeparator(getDiscountedInvoiceAddonLineTotal(invoiceAddon, getRentalLength()))
                        }}
                                            </span>
                </td>
            </tr>
            <tr v-if="parseFloat(cart.discount_amount) !== 0" class="summary-discount-amount">
                <td colspan="3">
                    {{trans('cart.Discount','Discount')}}
                </td>
                <td colspan="3" class="text-right">{{ currency_sign }}{{ thousandSeparator(cart.discount_amount) }}</td>
            </tr>
            <tr>
                <td colspan="3">
                    {{trans('cart.subtotal','SubTotal')}}
                </td>
                <td colspan="3">
                        <span class="pull-right">
                                        <del class="text-danger" v-if="cart.discount_amount > 0">{{
                                                currency_sign
                                            }}{{ thousandSeparator(cart.subtotal) }}</del>
                                        {{ currency_sign }}{{ thousandSeparator(cart.discounted_subtotal) }}
                                    </span>
                </td>
            </tr>
            <tr v-for="(location_tax, key, index) in location_taxes" :key="'loc_tax'+key"
                v-if="location_taxes && location_taxes.length > 0">
                <td colspan="3">
                    {{ location_tax.name }} ({{ roundNormal(location_tax.percentage, 2)*1 }}%)
                </td>
                <td colspan="3">
                        <span class="pull-right">
                                        {{
                                currency_sign
                            }}{{
                                thousandSeparator(perTaxAmount(location_tax))
                            }}
                                    </span>
                </td>
            </tr>
            <tr v-if="cart && cart.delivery_tax !== 0 && delivery_tax">
                <td colspan="3">
                    <span v-if="delivery_tax.type === 'flat'">{{ delivery_tax.front_text }}</span>
                    <span v-else>{{ delivery_tax.front_display_text }}</span>
                </td>
                <td colspan="3">
                    <span class="pull-right">
                        {{currency_sign}}{{thousandSeparator(cart.delivery_tax)}}
                    </span>
                </td>
            </tr>
            <tr>
                <th colspan="3">
                    {{trans('cart.Total_Cost','Total Cost')}}
                </th>
                <th colspan="3" class="text-right">
                    {{ currency_sign }}{{ thousandSeparator(cart.total) }}
                </th>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>

import {mapState, mapGetters} from "vuex";

export default {
    name: 'Cart',
    props: ['fromWp'],
    data() {
        return {
            coupon_code: null,
        }
    },
    computed: {
        ...mapState(['currency_sign','cart', 'coupon', 'renters', 'cart', 'location_taxes', 'base_url', 'delivery_tax']),
        ...mapGetters(['getDiscountedRenterTotal', 'getRenterTotal', 'getAddonDailyPrice']),
    },
    mounted() {
        this.$store.dispatch('setSummaryPage');
        this.$forceUpdate();
    },
    methods: {
        ...mapGetters(['getRentalLength']),
        /**
         * Per-tax amount displayed in the cart breakdown. Honors per-addon
         * tax exclusions (Whistler-only feature).
         *
         * Tax base matches the server invoice formula:
         *   calc_tax_amount(discounted_subtotal - non_tax_total, percentage)
         * where non_tax_total uses discounted amounts for tax-free add-ons.
         */
        perTaxAmount(location_tax) {
            let base = this.calc_tax_amount(
                (this.cart.discounted_subtotal - this.cart.non_tax_total),
                location_tax.percentage,
                6
            );

            let excluded_revenue = 0;
            let tax_id = Number(location_tax.id);

            (this.renters || []).forEach((renter) => {
                (renter.add_ons || []).forEach((addon) => {
                    if (addon.tax_free) return;
                    let excluded = addon.excluded_tax_ids;
                    if (!Array.isArray(excluded) || excluded.length === 0) return;
                    if (excluded.map(Number).indexOf(tax_id) === -1) return;

                    let multiplier = addon.pricing === 'one_time' ? 1 : (renter.number_of_days || 0);
                    excluded_revenue += this.getDiscountedAddonLineTotal(addon, renter, multiplier);
                });
            });

            let invoice_addons = (this.cart && this.cart.invoice_addons) ? this.cart.invoice_addons : [];
            invoice_addons.forEach((addon) => {
                if (addon.tax_free) return;
                let excluded = addon.excluded_tax_ids;
                if (!Array.isArray(excluded) || excluded.length === 0) return;
                if (excluded.map(Number).indexOf(tax_id) === -1) return;

                let multiplier = addon.pricing === 'one_time' ? 1 : this.getRentalLength();
                excluded_revenue += this.getDiscountedInvoiceAddonLineTotal(addon, multiplier);
            });

            if (excluded_revenue > 0) {
                base -= this.calc_tax_amount(excluded_revenue, location_tax.percentage, 6);
            }
            return base;
        },
        isPackageEligibleForDiscount(renter) {
            // If no coupon is applied, no discount
            if (!this.coupon) {
                return false;
            }

            // If coupon has no package restrictions, apply to all packages
            if (!this.coupon.applicable_packages || this.coupon.applicable_packages.length === 0) {
                return true;
            }

            // Check if this renter's package is in the applicable packages list
            return this.coupon.applicable_packages.includes(renter.package_resort_id);
        },
        isAddonEligibleForDiscount(addon) {
            if (!this.coupon || !this.coupon.addon_discount) {
                return false;
            }

            if (!this.coupon.applicable_addons || this.coupon.applicable_addons.length === 0) {
                return true;
            }

            return this.coupon.applicable_addons.includes(addon.id);
        },
        getDiscountedAddonUnitPrice(addon) {
            let unitPrice = this.getAddonDailyPrice(addon);
            if (this.coupon && this.coupon.addon_discount && this.isAddonEligibleForDiscount(addon)) {
                return this.getDiscountedPrice(unitPrice, this.coupon.addon_discount);
            }
            return unitPrice;
        },
        getDiscountedAddonLineTotal(addon, renter, multiplier) {
            return this.getDiscountedAddonUnitPrice(addon) * parseInt(addon.qty) * multiplier;
        },
        getDiscountedInvoiceAddonLineTotal(invoiceAddon, multiplier) {
            let unitPrice = this.getAddonDailyPrice(invoiceAddon);
            if (this.coupon && this.coupon.addon_discount && this.isAddonEligibleForDiscount(invoiceAddon)) {
                unitPrice = this.getDiscountedPrice(unitPrice, this.coupon.addon_discount);
            }
            return unitPrice * parseInt(invoiceAddon.qty) * multiplier;
        },
        trans(key, defaultValue,msg=null) {
            let translation = '';
            if(msg){
                translation = this.$t(key,{message:msg});
            }else{
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
        getStaticPercentPrice(subTotal, price, max_price) {
            let addon_price = this.getDiscountRate(subTotal, price);
            //if price after multiply with number of days exceeded than needs to set max_price
            if (max_price && (addon_price > max_price)) {
                addon_price = max_price;
            }
            return addon_price;
        },
        deleteRenter(renter, index) {
            let _this = this;
            swal({
                    title: "Are you sure?",
                    text: "You want to delete this renter?",
                    // type: "warning",
                    imageUrl: "/images/warning-alert.png",  // Replace with the path to your custom image
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, do it!",
                    closeOnConfirm: true
                }, function (isConfirm) {
                    if (isConfirm) {
                        if (index > -1) {
                            var cartPkg = _this.cart.packages.find(item => item.package_resort_id === renter.package_resort_id)
                            _this.renters.splice(index, 1)
                            if(cartPkg) {
                                cartPkg.qty = cartPkg.qty - 1;
                                cartPkg.total = _this.$store.getters.getDiscountedPackageTotal(cartPkg);
                            }
                            _this.$store.dispatch('setSummaryPage');
                            _this.$forceUpdate();
                        }
                    }
                }
            );

        },
    }
}
</script>
<style>
.cart-card-div{
    font-size: 16px;
}
</style>

